import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '../backend';
import { onlineOfflineBackend } from './online-offline.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { onlineOfflineReducer } from './online-offline.reducer';

// FIXME: remove that
backend.onlineOffline = onlineOfflineBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('onlineOffline', onlineOfflineReducer),
    /* DatastoreBackendModule.forFeature(
      'onlineOffline',
      onlineOfflineBackend,
    ),*/
  ],
})
export class DatastoreOnlineOfflineModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/online-offline/online-offline.module.ts